import { Fragment } from "react";
import {
    Dialog,
    DialogPanel,
    Transition,
    TransitionChild
} from "@headlessui/react";

function cn(...classes) {
    return classes.filter(Boolean).join(" ");
}

const AppModal = ({
    isOpen,
    onClose,
    children,
    className,
    isFullScreen
}) => {
    return (
        <>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog
                    as='div'
                    className='fixed inset-0 z-[1000] overflow-y-auto'
                    onClose={onClose}
                >
                    <TransitionChild
                        as={Fragment}
                        enter='ease-out duration-300'
                        enterFrom='opacity-0'
                        enterTo='opacity-100'
                        leave='ease-in duration-200'
                        leaveFrom='opacity-100'
                        leaveTo='opacity-0'
                    >
                        <div className='bg-black-2/80 fixed inset-0' />
                    </TransitionChild>

                    <div className='fixed inset-0 overflow-y-auto scrollbar'>
                        <div
                            className={cn(
                                "flex items-center justify-center min-h-full text-center",
                                isFullScreen ? "p-0" : "p-4"
                            )}
                        >
                            <TransitionChild
                                as={Fragment}
                                enter='ease-out duration-300'
                                enterFrom='opacity-0 scale-95'
                                enterTo='opacity-100 scale-100'
                                leave='ease-in duration-200'
                                leaveFrom='opacity-100 scale-100'
                                leaveTo='opacity-0 scale-95'
                            >
                                <DialogPanel
                                    className={cn(
                                        "rounded-xl border border-gray-8 w-full overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl",
                                        isFullScreen ? "w-full h-full p-0" : "max-w-md",
                                        className
                                    )}
                                >
                                    {children}
                                </DialogPanel>
                            </TransitionChild>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    );
};
export default AppModal;
